var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"controls":"","width":"600","height":"400"}},[_c('source',{attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }